import type { TableColumnConfig } from '../../../data/table-column-config';
import { TrueFalseCellComponent } from './true-false-cell.component';
import type { TrueFalseCellParameters } from './true-false-cell-parameters';
import type { TranslateAbleText } from '@pct-ng/i18n';

export function createTrueFalseColumn<T>(
  fieldId: string,
  fieldName: keyof T,
  label: TranslateAbleText,
  icons: TrueFalseCellParameters = {
    trueIcon: 'pct-mdi-check',
    falseIcon: 'pct-mdi-close-circle-outline',
  },
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: fieldId,
    field: fieldName,
    label,
    cellContent: TrueFalseCellComponent,
    cellCustomContent: () => icons,
    sortable,
  };
}
